// Welcome Modal
document.addEventListener('DOMContentLoaded', function () {

    // Feedback "Später" Button
    const dismissFeedbackBtn = document.getElementById('dismissFeedback');
    if (dismissFeedbackBtn) {
        dismissFeedbackBtn.addEventListener('click', function () {
            // Verstecke die Feedback-Karte
            const feedbackCard = this.closest('.row');
            if (feedbackCard) {
                feedbackCard.style.display = 'none';
            }
        });
    }
});
